import { INotification } from "./notifications.slice";

export interface INotificationsSlice {
  notifications: INotification[];
}

export const initialState: INotificationsSlice = {
  notifications: [],
};
